export const sleep = (time: number) => {
  return new Promise(resolve => setTimeout(resolve, time))
}

export const isNullOrUndefined = (value: any) => {
  return value === null || value === undefined
}
